import { EXTERNAL_URLS } from '@/config/constants'

export const getLinkByLocale = (lang: string | undefined) => {
  if (!lang || !EXTERNAL_URLS.CROP_BIODIVERSITY[lang]) {
    return EXTERNAL_URLS.CROP_BIODIVERSITY.en
  }

  return EXTERNAL_URLS.CROP_BIODIVERSITY[lang]
}
